<template>
  <div class="login">
    <!-- bg-login -->
    <div class="d-flex justify-content-between padding-header">
      <!-- style="background-color: var(--blue) !important" -->
      <div class="d-flex align-items-center">
        <img
          v-if="getOrganizationDetails.org_name == 'Empire Cinemas'"
          src="@/assets/img/pos/Empire_logo.jpeg"
          width="50"
          class="login-brand mx-3"
        />
        <!-- <img
          v-else
          src="@/assets/img/logos/logo-dark.png"
          width="135"
          class="login-brand"
        /> -->
        <img
          v-else
          src="@/assets/img/logos/Nuvio_Black.png"
          width="135"
          class="login-brand"
        />
        <div class="d-block" v-if="false">
          <h3
            v-if="getOrganizationDetails.org_name == 'Empire Cinemas'"
            class="mb-0 text-uppercase header-font-main"
          >
            EMPIRE CINEMAS
          </h3>
          <h3 class="mb-0 header-font-main" v-else>
            brij.<span class="text-uppercase">Cinema</span>
          </h3>
          <p
            class="mb-0 footer-text"
            v-if="getOrganizationDetails.org_name !== 'Empire Cinemas'"
          >
            From Cinema Owners to Cinema Owners
          </p>
        </div>
      </div>
      <img
        v-if="getOrganizationDetails"
        :src="getOrganizationDetails.org_logo_url"
        :height="
          String(getOrganizationDetails.org_name)
            .toLowerCase()
            .includes('xanadu')
            ? '90'
            : String(getOrganizationDetails.org_name)
                .toLowerCase()
                .includes('europe')
            ? '70'
            : '50'
        "
        :width="
          String(getOrganizationDetails.org_name)
            .toLowerCase()
            .includes('xanadu')
            ? '140'
            : String(getOrganizationDetails.org_name)
                .toLowerCase()
                .includes('europe')
            ? '170'
            : '200'
        "
        class="mx-2 d-flex justify-contant-center align-items-center"
      />
      <!-- <div class="d-block" v-else>
        <img
          src="@/assets/img/pos/BRIJ (3).svg"
          height="auto"
          width="250px"
          class="mx-2 d-flex justify-contant-center alig-items-center"
        />
    
      </div> -->
    </div>
    <form @submit.prevent.stop="checkOnlyAuthenticator()">
      <!-- bg-login -->
      <div
        class="
          app-login-wrapper
          
          align-items-center
          positioning-text-bubble
        "
      >
        <div class="d-flex align-items-center orgLogo"></div>
        <!-- ORG LOGO -->

        <!-- ORG LOGO END -->
        <div class="app-login-box">
          <h3 v-if="origin.includes('localhost')" class="text_domain ">
            Localhost {{ getOrganizationDetails.org_name }}
          </h3>
          <h3 v-else-if="origin.includes('-stg')" class="text_domain ">
            {{ getOrganizationDetails.org_name }}
          </h3>

          <h3 v-else-if="origin.includes('-dev')" class="text_domain ">
            {{ getOrganizationDetails.org_name }}
          </h3>

          <!--h3 v-else class="text_domain bg-pink">
                      {{ getOrganizationDetails.org_name }}
                      </h3--->
          <!-- <div class="app-login-container dash_log_img"> -->
          <div
            :class="
              getOrganizationDetails.org_name == 'Empire Cinemas'
                ? 'app-login-container dash_log_img'
                : 'app-login-container dash_log_img'
            "
          >
            <!---img
              src="@/assets/img/logos/logo-dark.png"
              height="auto"
              width="130"
              class="login-brand"
            /--->
            <!-- <form> -->
            <div class="col-md-7 mx-auto pt-5 pb-3">
              <div class="row">
                <div class="col-md-12 mb-4">
                  <div class="input-material">
                    <img
                      src="@/assets/img/icons/login-user.png"
                      class="login-icon"
                    />
                    <input
                      type="text"
                      class="pr-5"
                      placeholder="Username"
                      v-model="username"
                      :disabled="!chrome"
                      required="required"
                      name="username"
                      style="border-radius: 15px !important"
                    />
                    <!--label style="background-color:transparent;">{{ $t("username") }}</label--->
                  </div>
                </div>

                <div class="col-md-12 mb-4">
                  <div class="input-material">
                    <img
                      src="@/assets/img/icons/login-password.png"
                      class="login-icon"
                    />
                    <img
                      width="18"
                      height="18"
                      @click="togglePassword()"
                      class="show-password-icon"
                      v-if="passwordType == 'password'"
                      src="@/assets/img/icons/show-password.svg"
                    />
                    <img
                      width="18"
                      height="18"
                      @click="togglePassword()"
                      class="show-password-icon"
                      v-if="passwordType == 'text'"
                      src="@/assets/img/icons/hide-password.svg"
                    />
                    <input
                      name="password"
                      :disabled="!chrome"
                      placeholder="Password"
                      v-model="password"
                      :type="passwordType"
                      style="
                        padding-right: 75px;
                        border-radius: 15px !important;
                      "
                    />
                    <!-- @keyup.enter.stop="onLogin()" -->
                    <!--label>{{ $t("password") }}</label--->
                  </div>
                </div>
                <div class="col-md-6 mb-4 text-left">
                  <!-- <router-link to="pos-login" style="color: white"
                    >POS {{ $t("signin") }}?</router-link
                  > -->
                </div>

                <div class="col-md-6 mb-4 text-right">
                  <router-link style="color: #fff" v-b-modal.Forget-Modal to
                    >{{ $t("forgot") }} {{ $t("password") }}?</router-link
                  >
                </div>

                <!--  -->

                <div class="col-md-12 mb-4 text-center d-flex align-items-end">
                  <div class="d-flex justify-content-end button-flex">
                    <button
                      :disabled="!chrome"
                      type="submit"
                      class="btn-blue-lg"
                      style="border-radius: 12px"
                    >
                      <span class="mr-2">{{ $t("signin") }}</span>
                      <img
                        src="@/assets/img/icons/arrow-right.svg"
                        height="auto"
                        width="15"
                      />
                    </button>
                  </div>
                  <div
                    class="server-name d-flex justify-content-end"
                    style="line-height: 1; min-width: 117px"
                    v-if="!isMobile"
                  >
                    <span> Version </span>
                    <span> {{ semver }} </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- </form> -->
          </div>
        </div>
      </div>

      <footer class="bg-login" v-if="false">
        <div
          class="d-flex justify-content-center align-items-center padding-top"
        >
          <div v-if="getOrganizationDetails.org_name != 'Empire Cinemas'">
            <p class="footer-text">
              Made with Love & Passion from India and Switzerland
              <span class="mx-2">|</span> Copyright 2022 by brij cinematic
              services Ltd
            </p>
          </div>
          <div v-else>
            <p class="footer-text">Copyright 2022 by brij</p>
          </div>
        </div>
      </footer>
    </form>

    <!-- v-on:submit.prevent.self="onForgetModalSubmit" -->
    <b-modal
      ref="Ref-Forget-Modal"
      title="Reset Password"
      id="Forget-Modal"
      hide-footer
      centered
    >
      <form>
        <div class="modal-login-box">
          <div class="row">
            <div class="col-md-12 my-4" v-if="usernameField">
              <div class="input-material">
                <img
                  src="@/assets/img/icons/login-user.png"
                  class="login-icon"
                />
                <input
                  v-model="forgetPassword.username"
                  name="uname"
                  id="uname"
                  type="text"
                  class="pr-5"
                  placeholder="."
                  v-validate="'required'"
                />
                <label>{{ $t("username") }}</label>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('uname')">{{
                  errors.first("uname")
                }}</span>
              </p>
              <div class="text-center mt-3">
                <button
                  @click.prevent.stop="onUsernameConfirm()"
                  class="btn-blue w-50"
                >
                  <span>{{ $t("confirm") }}</span>
                </button>
              </div>
            </div>

            <div class="col-md-12 my-4" v-if="OtpFeild">
              <div class="input-material">
                <input
                  type="text"
                  v-model="otp"
                  name="otpnumber"
                  id="otpnumber"
                  v-validate="'required'"
                />
                <label class="shift-up">{{ $t("OTP") }}</label>
              </div>
              <label v-if="OtpFeild"
                >We have sent you an e-mail with OTP.</label
              >
              <br />
              <label v-if="minutes >= 0 && seconds >= 0"
                >OTP Expire in : {{ minutes }} : {{ seconds }}</label
              >
              <p v-else class="error_message">OTP Expired. Please Try Again</p>
              <p v-if="submitted && otp.length == 0" class="error_message">
                {{ errmsg }}
              </p>

              <div class="text-center d-flex mt-3">
                <!--<button @click.prevent.stop="onBackHandler()" class="btn-blue w-50 mr-1">-->
                <!--  <span>{{ $t('back') }}</span>-->
                <!--</button>-->
                <b-button
                  @click.prevent.stop="onBackHandler()"
                  class="btn-outline-grey w-50 mr-1"
                  variant="default"
                >
                  <span>{{ $t("back") }}</span>
                </b-button>
                <button
                  v-if="minutes >= 0 && seconds >= 0"
                  @click.prevent.stop="onOTPConfirm()"
                  class="btn-blue w-50"
                >
                  <span>{{ $t("confirm") }}</span>
                </button>
                <button
                  v-else
                  @click.prevent.stop="onResend()"
                  class="btn-blue w-50"
                >
                  <span>{{ $t("resend") }}</span>
                </button>
              </div>
            </div>

            <div class="w-100" v-if="updatePasswordFeild">
              <div class="col-md-12 my-4">
                <div class="input-material">
                  <img
                    src="@/assets/img/icons/login-password.png"
                    class="login-icon"
                  />
                  <input
                    v-model="forgetPassword.password"
                    type="password"
                    name="forgotpassword"
                    id="forgotpassword"
                    ref="forgotpassword"
                    v-validate="{
                      required: 'required',
                      regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                    }"
                  />
                  <label class="shift-up">{{ $t("password") }}</label>
                </div>
                <p
                  v-if="submitted && errors.has('forgotpassword')"
                  class="error_message"
                >
                  {{ errors.first("forgotpassword") }}
                </p>
              </div>

              <div class="col-md-12 mb-4">
                <div class="input-material">
                  <img
                    src="@/assets/img/icons/login-password.png"
                    class="login-icon"
                  />
                  <input
                    v-model="forgetPassword.confirmPassword"
                    type="password"
                    name="forgotconfirm"
                    id="forgotconfirm"
                    v-validate="'required|confirmed:forgotpassword'"
                  />
                  <label class="shift-up">{{ $t("confirmpassword") }}</label>
                </div>
                <p
                  v-if="submitted && errors.has('forgotconfirm')"
                  class="error_message"
                >
                  {{ errors.first("forgotconfirm") }}
                </p>
              </div>

              <div class="col-md-12 text-center d-flex mb-3">
                <button
                  @click.prevent.stop="onPasswordBackHandler()"
                  class="btn-blue w-50 mr-1"
                >
                  <span>{{ $t("back") }}</span>
                </button>
                <button
                  @click.prevent.stop="onForgetModalSubmit"
                  class="btn-blue w-50"
                >
                  <span>{{ $t("confirm") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <TwoFAModal
      :openModal="showModal"
      @onConfirm="confirmation"
      @onClose="ResetVariable"
      :onlyAuthenticator="onlyAuthenticator"
    ></TwoFAModal>
  </div>
</template>
<script>
  import UserService from "@/services/UserService";
  import TwoFAModal from "./2FAModal";
  import Nav from "@/Nav";
  import { mapActions, mapGetters } from "vuex";
  import moment from "moment";

  export default {
    name: "Login",
    components: { TwoFAModal },
    data() {
      return {
        origin: window && window.origin ? window.origin : "",
        username: "",
        password: "",
        passwordType: "password",
        submitted: false,
        usernameField: true,
        OtpFeild: false,
        updatePasswordFeild: false,
        otpsent: true,
        onlyAuthenticator: false,
        // username: "superadmin",
        // password: "Smi@123",

        otp: "",
        user_id: null,
        errmsg: "",
        inserted_id: "",

        forgetPassword: {
          email_id: null,
          username: "",
          verification_id: null,
          otp: null,
          user_id: null,
          password: "",
          confirmPassword: "",
        },
        timer: null,
        totalTime: 10 * 60,
        chrome: true,
        showModal: false,
        secretCode: null,
        // resetButton: false

        // username: "gogoadmin",
        // password: "password123"
      };
    },
    beforeMount() {
      if (
        window.location.href ==
        "https://brij-dashboard-v1.empirecinemas.com/#/login"
      ) {
        window.location.href =
          "https://ksa-dashboard-v1.empirecinemas.com/#/login";
      }
    },
    computed: {
      ...mapGetters(["getOrganizationDetails"]),
      minutes: function() {
        const minutes = Math.floor(this.totalTime / 60);
        // console.log("minutes :", minutes);
        if (minutes == -1) {
          this.otpexpiry();
          this.stopTimer();
        }
        return this.padTime(minutes);
      },
      semver() {
        return "V 1.0.0";
      },
      seconds: function() {
        const seconds = this.totalTime - this.minutes * 60;
        // console.log("seconds :", seconds);
        return this.padTime(seconds);
      },
    },
    mounted: function() {
      this.checkUserLoggedInFunction();
      var isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor);
      // if (!isChrome) {
      //   this.$toasted.show(
      //     "Sorry! please use Google Chrome and Not firefox or any other browser"
      //   );
      //   this.chrome = false;
      // }
    },
    methods: {
      ...mapActions(["fetchUserHotPickModules"]),
      ResetVariable: function(value) {
        this.secretCode = "";
        this.showModal = value;
      },
      confirmation: function(values) {
        if (this.showModal && values) {
          this.secretCode = values;
          this.onLogin();
        }
        if (
          window.location.href ==
            "https://iraq-dashboard-v1.empirecinemas.com/#/login" ||
          window.location.href ==
            "http://iraq-dashboard-v1.empirecinemas.com/#/login"
        ) {
          window.location.href =
            "https://iraq-dashboard-v-1.empirecinemas.com/#/login";
        }
      },
      check2FAIsEnabled: function() {
        let loader = this.$loading.show();
        let payload = {
          username: this.username,
          password: this.password,
        };

        UserService.Check2FAEnabled(payload)
          .then((response) => {
            const { data } = response;

            if (data && data.status) {
              if (data.isEnabled) {
                this.showModal = !this.showModal;
                // this.$refs["Ref-2fa-Modal"].show();
              } else {
                this.onLogin();
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      checkOnlyAuthenticator: function() {
        let loader = this.$loading.show();
        let payload = {
          username: this.username,
        };

        UserService.CheckOnlyAuthenticatorEnabled(payload)
          .then((resp) => {
            const { data } = resp;
            if (data.status) {
              if (data.isEnabled) {
                this.onlyAuthenticator = true;
                this.showModal = !this.showModal;
              } else {
                if (!this.password) {
                  this.$toasted.show("Please enter your password");
                } else {
                  this.check2FAIsEnabled();
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      // ClearData: function () {
      //   this.secretCode = "";
      //   this.$refs["Ref-2fa-Modal"].hide();
      // },
      togglePassword() {
        if (this.passwordType == "password") {
          this.passwordType = "text";
        } else {
          this.passwordType = "password";
        }
      },

      checkUserLoggedInFunction() {
        UserService.checkUserLoggedIn({}).then((response) => {
          const { data } = response;
          let HashId = this.$cookie.get("BRHSID");
          if (data.status && HashId) {
            this.$router
              .push({
                path: "/",
              })
              .catch((err) => {
                this.$toasted.show(err.message || "Something went wrong.");
              });
          } else if (data.errorCode == 409) {
            this.onLogout();
          }
        });
      },
      onLogout: function() {
        UserService.removeToken()
          .then((res) => {
            const { data } = res;
            if (data.status == true) {
              window.localStorage.removeItem("JWT_TOKEN");
              window.localStorage.clear();
              this.$router.push({ path: "/login" });
              this.$cookie.delete("BRHSID");
            } else {
              window.localStorage.removeItem("JWT_TOKEN");
              window.localStorage.clear();
              this.$router.push({ path: "/login" });
              this.$cookie.delete("BRHSID");
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$router.push({ path: "/login" });
            this.$toasted.show("Token not removed");
          });
      },
      onForgetModalSubmit: function() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          if (valid) {
            let loader = this.$loading.show();
            UserService.ForgetPassword(this.forgetPassword)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  data.message ? this.$toasted.show(data.message) : "";
                  this.$refs["Ref-Forget-Modal"].hide();
                  this.updatePasswordFeild = false;
                  this.usernameField = true;
                  this.otp = "";
                  this.forgetPassword.username = "";
                } else {
                  this.$toasted.show(
                    data.message ||
                      "Sorry! Something went wrong. kindly contact your administrator"
                  );
                }
              })
              .catch(this._CatchError)
              .finally(() => {
                setTimeout(() => loader.hide(), 1000);
              });
          }
        });
      },

      onUsernameConfirm() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          // console.log("valid :", valid);
          if (valid) {
            let payload = {
              username: this.forgetPassword.username,
              otpFlag: this.otpsent,
            };
            UserService.VerifyUsername(payload).then((response) => {
              // console.log("response :", response);
              const { data } = response;
              if (data.status) {
                this.usernameField = false;
                this.OtpFeild = true;
                this.user_id = data.id;
                this.inserted_id = data.ins_id;
                this.submitted = false;
                this.startTimer();
                // this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            });
          }
        });
      },

      startTimer: function() {
        console.log("object :", typeof this.timer);
        console.log("this.timer :", this.timer);
        this.timer = null;

        this.timer = setInterval(() => this.countdown(), 1000);
        // this.resetButton = true;
        // this.title = "Greatness is within sight!!"
      },
      stopTimer: function() {
        clearInterval(this.timer);
        this.timer = null;
      },
      countdown: function() {
        // console.log("this.totalTime :", this.totalTime);
        if (this.totalTime >= 0) {
          this.totalTime--;
        }
      },
      padTime: function(time) {
        return (time < 10 ? "0" : "") + time;
      },

      otpexpiry() {
        console.log("object :");
        let payload = {
          username: this.forgetPassword.username,
          uni_id: this.inserted_id,
        };
        console.log("payload :", payload);
        UserService.OTPExpiry(payload).then((response) => {
          console.log("response :", response);
        });
      },

      onBackHandler() {
        this.OtpFeild = false;
        this.usernameField = true;
        this.stopTimer();
        this.forgetPassword.username = "";
        this.forgetPassword.verification_id = null;
        this.forgetPassword.otp = null;
        this.forgetPassword.user_id = null;
      },

      onPasswordBackHandler() {
        this.forgetPassword.password = "";
        this.forgetPassword.confirmPassword = "";
        this.forgetPassword.verification_id = null;
        this.forgetPassword.otp = null;
        this.forgetPassword.user_id = null;
        this.updatePasswordFeild = false;
        this.usernameField = true;
      },

      onResend() {
        this.timer = null;
        // this.startTimer();
        this.totalTime = 1 * 60;
        this.onUsernameConfirm();
      },

      onOTPConfirm() {
        this.submitted = true;

        if (this.otp.length == 0) {
          this.errmsg = "Please enter OTP.";
          return;
        } else {
          this.$validator.validate().then((valid) => {
            console.log("valid :", valid);
            if (valid) {
              let payload = {
                userid: this.user_id,
                otpnumber: this.otp,
                verification_id: this.inserted_id,
              };
              UserService.VerifyOTP(payload).then((response) => {
                // console.log("response :", response);
                const { data } = response;
                if (data.status) {
                  this.OtpFeild = false;
                  this.forgetPassword["verification_id"] = this.inserted_id;
                  this.forgetPassword["otp"] = this.otp;
                  this.forgetPassword["user_id"] = this.user_id;
                  this.updatePasswordFeild = true;
                  this.submitted = false;
                  this.stopTimer();
                } else {
                  this.forgetPassword["verification_id"] = null;
                  this.forgetPassword["otp"] = null;
                  this.forgetPassword["user_id"] = null;
                  this.$toasted.show(data.message || "Something Went Wrong!");
                  this.submitted = false;
                  this.stopTimer();
                }
              });
            }
          });
        }
      },

      onLogin: function() {
        let loader = this.$loading.show();
        let payload = {
          username: this.username,
          password: this.password,
          onlyAuthenticator: this.onlyAuthenticator,
        };
        if (this.secretCode && this.secretCode.length > 0) {
          payload.secretCode = this.secretCode;
        }
        UserService.LoginUser(payload)
          .then(async (response) => {
            const { data } = response;
            if (data.status) {
              this.secretCode = "";
              this.showModal = false;
              // this.$refs["Ref-2fa-Modal"].hide();
              if (data.data.user.role_name == "POS Operator") {
                this.$toasted.show(
                  "Sorry! your are a POS user, you will need to login from a terminal"
                );
                return;
              }
              if (
                data.data.user.role_name == "Aggregator" ||
                data.data.user.role_id == 10
              ) {
                this.$toasted.show(
                  "Sorry! your are an Aggregator or Third Party User, you cannot Login from this dashboard"
                );
                return;
              }
              if (data.data.user.role_name == "Kitchen Manager") {
                this.$toasted.show(
                  "You have no access to dashboard, Please Login from Kitchen Display"
                );
                return;
              }
              window.localStorage.setItem("JWT_TOKEN", data.data.token);
              this.$store.dispatch("setUserProfile");
              let finalObj = {};
              let PromiseArray = this.usersArray.map((x) => {
                finalObj[x] = data.data.user[x] || null;
              });
              // TODO - Store the role ID and module permission of the user
              // this.secureStore.set("role_id", data.data.role_id);
              this.secureStore.set("module_list", data.data.activeModules);
              this.secureStore.set(
                "module_categories_list",
                data.data.activeModulesCategory
              );
              //activeModulesCategory

              await Promise.all(PromiseArray);
              // USER INFO KEY: US-User INFO = USINFO
              console.log("finalObj::::::::::::::::: :>> ", finalObj);
              this.secureStore.set("USINFO", finalObj);
              // HASH TOKEN KEY: BR-BRIJ HS: HASH ID =BRHSID
              this.$cookie.set("BRHSID", data.data.token, {
                expires: "1Y",
              });
              // console.log("object :", this.secureStore.get("USINFO"));
              // BRLF: BRIJ LOGIN FROM
              // let trimRoleName = data.data.user.role_name.trim();
              if (data.data.user.role_name == "Screen Scheduling") {
                this.$cookie.set("BRLF", "Screen-Scheduling");
                this.$router.push({
                  path: "/screening-schedule-url",
                });
                return;
              } else if (data.data.user.role_name == "FNB Order") {
                this.$cookie.set("BRLF", "FNB-Order");
                this.$router.push({
                  path: "/fnb-orders-url",
                });
                return;
              } else {
                this.$cookie.set("BRLF", "admin-login");
              }

              // console.log(
              //   "this.secureStore.get :",
              //   this.secureStore.get("USINFO")
              // );

              // FOR PERMISSION KEY: BR-BRIJ UR:USER PM: PERMISSION = BRURPM
              this.secureStore.set("BRURPM", {
                role_name: data.data.user.role_name,
              });
              try {
                this._GetGlobalOptions();
                this.fetchUserHotPickModules();
                this.$store.dispatch("setDropdownCinema"); // PRESET DROPWDOWN CINEMA IN REPORT IF ONLY ONE CINEMA
                window.localStorage.setItem(
                  "last_loggedin_time",
                  moment().format("YYYY-MM-DD HH:mm")
                );
                window.localStorage.setItem(
                  "session_expiry_time",
                  moment()
                    .add(12, "hours")
                    .format("YYYY-MM-DD HH:mm")
                );
              } catch (error) {
                this.$toasted.show(
                  "Error while fetching global options " + error
                );
              }

              if (data.data.user.role_name == "Cinema Manager") {
                this.$router.push({
                  path: "cinema-manager/view-schedule",
                });
              } else if (data.data.user.role_name == "Analytics Manager") {
                // Go To Mobile Dashboard URL
                this.$router.push({
                  path: "/mobile/reports/Summary",
                });
              } else if (data.data.user.role_name == "Kitchen Manager") {
                this.$router.push({
                  path: "/kitchen-sales",
                });
              } else if (data.data.user.role_name == "Programming Manager") {
                this.$router.push({
                  path: "/reports/showoverview",
                });
              } else if (data.data.user.role_id > 11) {
                if (
                  data.data.activeModules &&
                  data.data.activeModules.length > 0
                ) {
                  let pushflag = false;
                  Nav.items.some((x) => {
                    x.children.some((y) => {
                      if (data.data.activeModules.includes(y.module_id)) {
                        // this.$router.push({ path: y.url });
                        this.$router.push({ path: "/" });
                        pushflag = true;
                        return true;
                      }
                    });
                    if (pushflag) {
                      return true;
                    }
                  });
                } else {
                  this.$router.push({
                    path: "/",
                  });
                }
              } else {
                // this.$router.push({
                //   path: "master"
                // });
                this.$router.push({
                  path: "/",
                });
              }
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
    },
  };
</script>

<style scoped>
  .show-password-icon,
  .hide-password-icon {
    top: 11px;
    right: 50px;
    position: absolute;
  }

  .app-login-container .input-material input {
    border-color: var(--lightgrey) !important;
  }

  .app-login-container .input-material input + label {
    top: -15px !important;
    font-size: 12px !important;
    background-color: transparent !important;
    color: var(--lightgrey) !important;
  }
  .app-login-container .input-material input::placeholder {
    color: var(--blue);
    font-weight: 500;
  }
  .orgLogo {
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .server-name {
    color: #fff;
    flex: 2;
    font-size: 11px;
    font-weight: bold;
  }
  .button-flex {
    flex: 3;
  }
  .bg-login {
    background-color: #f7fbfb !important;
    /* height: 100vh; */
  }
  .padding-header {
    padding: 20px;
  }
  .header-font-main {
    color: #122c6a;
    font-weight: bold;
  }
  .footer-text {
    color: #122c6a;
    font-weight: 500;
  }
  .text_domain {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding-bottom: 20px;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/login.vue